import { createIcon } from '@chakra-ui/react';

export const SocialTwitter = createIcon({
  displayName: `SocialTwitter`,
  viewBox: `0 0 36 30.212`,
  path: (
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3px"
      d="M34.5 4.5a16.35 16.35 0 0 1-4.71 2.3A6.72 6.72 0 0 0 18 11.295v1.5A15.99 15.99 0 0 1 4.5 6s-6 13.5 7.5 19.5a17.46 17.46 0 0 1-10.5 3c13.5 7.5 30 0 30-17.25a6.75 6.75 0 0 0-.12-1.25 11.58 11.58 0 0 0 3.12-5.5z"
      transform="translate(0 -2.868)"
    />
  ),
});
